@if (harvest.phases != null && harvest.phases.length > 0) {
  <div class="row" style="padding-bottom: 15px;">
    <div class="col-12">
      <h3>Phases</h3>
      <mat-accordion class="example-headers-align" multi>
        @for (phase of harvest.phases; track phase) {
          <mat-expansion-panel [disabled]="phase.strains == null || phase.strains.length == 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{phase.phaseName}}
              </mat-panel-title>
              @if (phase.strains != null && phase.strains.length > 0) {
                <mat-panel-description>
                  <span>
                    Plant Count: <span style="color: black">{{totalPlantCount(phase)}}</span>
                    @if (totalZoneCount(phase) != null) {
                      <span> | Zone Count:
                        <span style="color: #43a047; font-weight: bold;">[{{totalZoneCount(phase)}}]</span>
                      </span>
                    }
                  </span>
                </mat-panel-description>
              }
            </mat-expansion-panel-header>
            @if (zones.length > 0) {
              <div class="row">
                <div class="col-12">
                  @if (canEditHarvest) {
                    <button style="float:right;" type="button" mat-raised-button
                      (click)="assignZone(phase)">
                      Assign Zones
                    </button>
                  }
                </div>
              </div>
            }
            <div class="row">
              @if (phase.strains != null && phase.strains.length > 0) {
                <div class="col-12">
                  <h5>Strains</h5>
                  <ul>
                    @for (strain of phase.strains; track strain) {
                      <li style="padding-top: 15px;">
                        <div class="row" style="padding-bottom: 10px;">
                          <div class="col-3">
                            {{strain.strainName}}
                          </div>
                          <div class="col-3">
                            <mat-form-field>
                              <input [disabled]="!canEditHarvest" matInput type="number"
                                [(ngModel)]="strain.count" placeholder="{{phase.phaseName + ' Count'}}">
                            </mat-form-field>
                          </div>
                          <div class="col-6">
                            <app-zone-identifiers [zones]="zones" [selectedZones]="strain.zones">
                            </app-zone-identifiers>
                          </div>
                        </div>
                        <mat-divider></mat-divider>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
}